<template>
  <div v-title="$route.meta.title">
    <div class="page-heading"
         style="position:relative;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="true">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch">
        <div class="re-el-form__flex">
          <el-form-item label="任务上线时间"
                        prop="starttime">
            <el-date-picker
              v-model="search.starttime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="任务下线时间"
                        prop="endtime">
            <el-date-picker
              v-model="search.endtime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="任务更新时间"
                        prop="lastupdatetime">
            <el-date-picker
              v-model="search.lastupdatetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="项目"
                        prop="projectid">
            <remote-select class="width-max"
                           clearable
                           multiple
                           id-key="number"
                           label-key="name"
                           value-key="id"
                           @change="projectIdChanged()"
                           placeholder="请输入项目 名称/编号 进行搜索"
                           v-model="search.projectid"
                           :query-request="getProjectTable"
                           :find-request="getProjectDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="订单类型"
                        prop="type">
            <el-select v-model="search.type"
                       placeholder="请选择订单类型"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in getSortedTaskTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                <template v-if="item.deprecated">
                  <span style="float: left;color: #9ba0a5;">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}
                  </span>
                </template>
                <template v-else>
                  <span style="float: left;">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
                </template>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次"
                        prop="batchid">
            <remote-select class="width-max"
                           clearable
                           multiple
                           :disabled="!search.projectid"
                           id-key="number"
                           label-key="detail"
                           value-key="id"
                           placeholder="请输入批次 名称/编号 进行搜索"
                           v-model="search.batchid"
                           :query-request="(_) => getBatchTable(Object.assign({projectid: search.projectid}, _))"
                           :find-request="getBatchDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="订单状态"
                        prop="status">
            <el-select v-model="search.status"
                       multiple
                       placeholder="请选择订单状态"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.taskstatus"
                :key="item.value"
                :label="item.label"
                :value="String(item.value)">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务模板ID"
                        prop="templateid">
            <el-input placeholder="请输入任务模板id"
                      v-model="search.templateid"></el-input>
          </el-form-item>
          <el-form-item label="所在区域"
                        prop="taskmarketareaid">
            <el-select v-model="search.taskmarketareaid"
                       placeholder="请选择所在区域"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.taskmarketareaid"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="完成人ID"
                        prop="userid">
            <el-input placeholder="请输入完成人id"
                      v-model="search.userid"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="任务标题"
                        prop="text">
            <el-input placeholder="请输入关键字"
                      v-model="search.title"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="省市区"
                        prop="query_areas">
            <containment-area-cascader
              v-model="search.query_areas"
              placeholder="请选择省市区">
            </containment-area-cascader>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="mini">搜索
          </el-button>
          <el-button @click="resetForm('searchForm')"
                     size="mini">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel :on-refresh="onRefresh">
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button style="margin-left: 10px;"
                   type="primary"
                   size="mini"
                   @click="showExportSearchDialog">按搜索结果导出
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border>
        <template v-for="attr of orderArchivedFields">
          <el-table-column v-bind="attr" v-if="attr.prop === 'title'">
            <template slot-scope="scope">
              <router-link :to="'/order/detail/'+scope.row.orderid">
                <span style="color: rgb(88, 157, 248)">{{scope.row.title}}</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column v-bind="attr" v-else-if="attr.prop === 'userid'">
            <template slot-scope="scope">
              <router-link :to="'/users/table?keyword='+scope.row.userid"
                           v-if="scope.row.userid !== 0"
                           style="text-decoration:none">
                <span style="color:rgb(88,157,248);">{{scope.row.userid}}</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column v-bind="attr" v-else-if="attr.prop === 'marketname'">
            <template slot-scope="scope">
              <router-link :to="'/market/table?id='+scope.row.marketid"
                           target="_blank">
                {{scope.row.marketname}}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column v-bind="attr" v-else></el-table-column>
        </template>
        <el-table-column fixed="right"
                         label="操作"
                         width="150px"
        >
          <template slot-scope="scope">
            <router-link :to="'/order/review/'+scope.row.orderid" target="_blank">
              <el-button v-if="(scope.row.status !== 4)"
                         type="success"
                         size="mini">查看
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <el-dialog
      title="导出数据确认"
      :visible.sync="dialogBatchVisible"
      width="45%"
    >
      <div style="font-size: large">共导出{{pagination.total}}条数据</div>
      <el-checkbox class="margin t20"
                   v-model="exportAsync">后台异步导出（建议1w条数据以上时勾选，勾选后请于批量任务列表确认导出数据）
      </el-checkbox>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="onExportSearch(1)"
                   :disabled="pagination.total === 0"
                   size="mini">仅导出任务基本数据</el-button>
        <el-button type="primary"
                   @click="onExportSearch(0)"
                   :disabled="pagination.total === 0"
                   size="mini">导出任务全部数据</el-button>
        <el-button @click="dialogBatchVisible = false"
                   size="mini">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import taskMixins from '@views/task/task.mixins'
import ContainmentAreaCascader from '@views/area/components/ContainmentAreaCascader'

export default {
  mixins: [table, taskMixins],
  components: {
    ContainmentAreaCascader,
  },
  data () {
    return {
      search: {
        starttime: null,
        endtime: null,
        lastupdatetime: null,
        type: null,
        projectid: [],
        batchid: [],
        status: [],
        taskmarketareaid: null,
        userid: null,
        title: null,
        query_areas: [],
      },
      searchFieldType: {
        type: Number,
        status: Array,
        locked: Number,
        review_begin: Number,
        review_end: Number,
        templateid: Number,
        taskmarketareaid: Number,
        query_areas: Array,
      },
      dialogBatchVisible: false,
      exportAsync: false,
    }
  },
  computed: {
    ...Vuex.mapGetters('order', ['getSortedTaskTypes']),
  },
  methods: {
    ...request.map([
      'getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail',
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getOrderArchivedTable', params)
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.search.query_areas = []
    },
    projectIdChanged () {
      if (this.search.batchid.length > 0) {
        this.search.batchid = []
      }
    },
    onExportSearch (onlyBasic) {
      this.dialogBatchVisible = false
      let detail = {
        ...this.search,
        only_basic: onlyBasic,
        export_async: this.exportAsync,
        dashboard_format: false,
        convert_midan_task: false,
      }

      if (this.exportAsync) {
        return this.onExportAsync(detail)
      }

      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: (params) => request('exportOrderArchived', params),
        requestParams: detail,
        fileType: 'csv',
        type: 'array',
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    showExportSearchDialog () {
      this.dialogBatchVisible = true
      this.exportAsync = false
    },
    onExportAsync (detail) {
      return request.common('exportOrderArchived', detail).then(() => {
        return this.$message.success('创建成功，请在任务管理中心查看！')
      })
    },
  }
}
</script>

<style lang="scss"
       scoped>
// 带作用域的CSS
.el-table .cell {
  white-space: pre-wrap;
}
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/order/pages/OrderArchivedTable.vue